export const statusToString = (status) => {
    switch (status) {
        case 0:
            return 'OK';
        case 1:
            return 'Adding';
        case 3:
            return 'Pending Approval';
        case 4:
            return 'Updating';
        case 8:
            return 'Degraded';
        case 9:
            return 'Deleting';
        default:
            return 'Error';
    }
};
